<template>
  <div class="modal fade" data-backdrop="static" tabindex="-1" :id="id">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <form @submit.prevent="submitForm" class="form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ $t('events.participator.addParticipator') }}</h5>
            <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" @click.prevent="closeModal">
                <span class="svg-icon svg-icon-1">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                        fill="currentColor"/>
                  <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                        fill="currentColor"/>
                </svg>
              </span>
            </div>
          </div>
          <div class="modal-body">
            <RequiredText />
            <div class="row">
              <Select2
                  :parent-id="'#'+id"
                  containerClass="col-12 mt-auto mb-5"
                  :name="`${id}-gender`"
                  type="text"
                  :label="$t('user.gender')"
                  labelClass="form-label fs-6 text-black"
                  selectClass="form-select form-select-solid"
                  :isRequired="true" size="lg"
                  :placeholder="$t('user.civility')"
                  v-model="formData.gender"
                  :multiple="false">
                <option value="female">{{ $t('user.female') }}</option>
                <option value="male">{{ $t('user.male') }}</option>
              </Select2>
              <Input
                  containerClass="col-12 col-md-6 mt-auto mb-5"
                  :name="`${id}-lastname`"
                  type="text"
                  :label="$t('user.lastname')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true" size="lg"
                  :placeholder="$t('user.lastname_placeholder')"
                  v-model="formData.lastname"
              />
              <Input
                  containerClass="col-12 col-md-6 mt-auto mb-5"
                  :name="`${id}-firstname`"
                  type="text"
                  :label="$t('user.firstname')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="true" size="lg"
                  :placeholder="$t('user.firstname_placeholder')"
                  v-model="formData.firstname"
              />
              <Input
                  containerClass="col-12 col-md-6 mt-auto mb-5"
                  :name="`${id}-email`"
                  type="email"
                  :label="$t('user.email')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="false" size="lg"
                  :placeholder="$t('user.email_placeholder')"
                  v-model="formData.email"
              />
              <InputTel
                  :name="`${id}-phone`"
                  type="text"
                  :label="$t('user.phone')"
                  containerClass="col-md-6 mb-5"
                  labelClass="form-label fs-6 text-black"
                  inputClass="form-control form-control-sm form-control-solid"
                  v-model:phone="formData.phone"
                  v-model:phone-code="formData.phone_code"
                  :placeholder="$t('enter_phone')"
                  :isRequired="false" />
            </div>
            <div class="row">
              <Input
                  containerClass="col-12 col-md-6 mt-auto mb-5"
                  :name="`${id}-society`"
                  type="text"
                  :label="$t('user.society')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="false"
                  size="lg"
                  v-model="formData.company"
              />
              <Input
                  containerClass="col-12 col-md-6 mt-auto mb-5"
                  :name="`post-`+id"
                  type="text"
                  :label="$t('contacts.post')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="false"
                  size="lg"
                  v-model="formData.post"
              />
              <Select2
                  :parent-id="'#'+id"
                  container-class="col-12 col-md-6 mb-5"
                  :multiple="false"
                  :show-search="true"
                  labelClass="form-label fs-6 text-black"
                  selectClass="form-control form-select form-select-solid rounded-end-0 border-start"
                  :name="`status-`+id"
                  :label="$t('events.participator.status')"
                  v-model="formData.status_id"
                  :is-required="true">
                <option v-for="stat in status" :key="stat?.id" :value="stat?.id">{{ stat?.name }}</option>
              </Select2>
              <Input
                  containerClass="col-12 col-md-6 mb-5"
                  :name="`${id}-sector`"
                  type="text"
                  :label="$t('events.participator.sector')"
                  labelClass="form-label fs-6 text-black"
                  :inputClass="'form-control form-control-lg form-control-solid'"
                  :isRequired="false" size="lg"
                  v-model="formData.sector"
              />

            </div>

          </div>
          <div class="modal-footer">
            <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click="closeModal"></Button>
            <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="isLoading"></Button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script setup>

import {computed, defineProps, onMounted, ref, watch} from 'vue';
import { useStore } from "vuex";
import Button from "@/components/Button.vue"
import Select2 from '@/components/Select2.vue';
import RequiredText from "@/components/RequiredText.vue";
import InputTel from "@/components/InputTel.vue";
import Input from "@/components/Input.vue";
import {useLocales} from "@/composables/locales";

const { locale } = useLocales()

const store = useStore()

const emit = defineEmits(['created'])
const props = defineProps({
  eventId: {type: String, required: true},
  oldParticipators: {
    type: Array,
    default: () => []
  },
  id:{type: String, default:"add_participator_status"} ,
  parent:{type: String, default:""} ,
})

const formData = ref({
  gender: '',
  email: '',
  phone: '',
  phone_code: '',
  company: '',
  sector: '',
  post: '',
  firstname: '',
  lastname: '',
  event_id: props.eventId,
  type: '',
  status_id: ''
})
const isLoading = ref(false)

const contacts = computed(() => store.getters['contacts/getContacts'])
const types = computed(() => store.getters['events/getEventTypes'])
const statusEnums = computed(() => store.getters['events/getEventStatusEnum'])
const status = computed(() => store.getters['events/getEventStatus'])

watch(() => props.oldParticipators, (value) => {
  //formData.value = props.data
}, { deep: true })


function closeModal(){
  formData.value = null
  formData.value = {
    gender: '',
    email: '',
    phone: '',
    phone_code: '',
    company: '',
    sector: '',
    post: '',
    firstname: '',
    lastname: '',
    event_id: props.eventId,
    type: '',
    status_id: ''
  }
  if(props.parent) $('#'+props.parent).modal('toggle')
  $('#'+props.id).modal('toggle')
}

function submitForm() {
  isLoading.value = true
  store.dispatch('events/addParticipator', {...formData.value, phone_code: !formData.value.phone ? '' : formData.value.phone_code })
      .then(res => {
        window.toastr.success(i18n.global.t("notification.event_participator_created"))
        emit('created')
        store.dispatch('events/loadParticipators', props.eventId)
        formData.value={
          gender: '',
          email: '',
          phone: '',
          phone_code: '',
          company: '',
          sector: '',
          post: '',
          firstname: '',
          lastname: '',
          event_id: props.eventId,
          type: '',
          status_id: ''
        }
        isLoading.value = false

        if(props.parent) $('#'+props.parent).modal('toggle')
        $('#'+props.id).modal('toggle')
      })
      .catch(() => {})
      .finally(() => isLoading.value = false)
}

onMounted(() => {
  store.dispatch('events/loadEventStatusEnum')
  store.dispatch('events/loadEventStatus')
  store.dispatch('events/loadEventParticipatorType')
})

</script>
